import { COOKIE_CURRENT_ACCOUNT_SEARCH, COOKIE_CURRENT_ACCOUNT_TYPE } from '@/constants/cookies';
import { PRODUCT_CURRENT_ACCOUNTS } from '@/constants/products';
import { getCurrentAccounts, getCurrentAccountSearch } from '@/graphql/queries/banking/current-account';
import { createCurrentAccountSearch } from '@/graphql/mutations/banking/current-account';
import { getProviders } from '@/graphql/queries/shared/institution';
import lang from '@/lang/middleware/products/banking/current-accounts';

export default async ({ $apolloMutate, $apolloQuery, $cookies, redirect, store }) => {
  const searchError = _e => redirect(301, '/compare-current-accounts/');
  const searchSet = search => store.commit('search/SET_CURRENT_SEARCH', search);
  const code = $cookies.get(COOKIE_CURRENT_ACCOUNT_SEARCH);
  const accountType = $cookies.get(COOKIE_CURRENT_ACCOUNT_TYPE);
  if (code) {
    await $apolloQuery(getCurrentAccountSearch, { code }).then(searchSet).catch(searchError);
  } else if (accountType) {
    await $apolloMutate(createCurrentAccountSearch, { params: { accountType } }).then(searchSet).catch(searchError);
  } else {
    return searchError('No code or account type provided');
  }
  await $apolloQuery(getCurrentAccounts).then(accounts => store.commit('products/setList', accounts));
  await $apolloQuery(getProviders, { product: PRODUCT_CURRENT_ACCOUNTS }).then(providers => store.commit('providers/setList', providers));
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const description = store.$i18n.t('results.description');
  const title = store.$i18n.t('results.jumbotron.title');
  const subtitle = store.$i18n.t('results.jumbotron.subtitle');
  store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title });
  store.commit('pageContent/setHead', { description, title });
};
